import React, { useState, useEffect } from 'react';
import './expensetracker.css';

const ExpenseTracker = () => {
  const [empId, setEmpId] = useState("");
  const [empName, setEmpName] = useState("");
  const [designation, setDesignation] = useState("");
  const [city, setCity] = useState("");
  const [fuelRate, setFuelRate] = useState(""); 
  const [expenses, setExpenses] = useState([]); // Initialize state

  const [formData, setFormData] = useState({
    category: '',
    amount: '',
    description: '',
    startDate: '',
    endDate: '',
    campaignDescription: '',
    platform: '',
    expenseName: '',
    paymentMethod: '',
    receiptAttachment: null,
    travelExpenseMode: '',
    fuelType: '',
    fuelPerKm: '',
    distanceTravelled: '',
    accommodationType: '',
    accommodationAmount: '',
    accommodationDuration: '',
    accommodationReceipt: null,
    travelExpenseDescription: '',
    city: '', // Add city
  });

  const [message, setMessage] = useState(""); 

  const categories = ["Travel Expenses", "Marketing and Advertising", "Miscellaneous Expenses","Accommodation Expenses"];

  const fetchEmployeeDetails = async (empId) => {
    try {
      const response = await fetch(`https://cleezoclass.com:8443/api/employeeProfile/${empId}`);
      if (response.ok) {
        const data = await response.json();
        setEmpName(data.empName);
        setDesignation(data.designation);
      } else {
        console.error('Error fetching employee details:', response.status);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const handleTravelExpensesCalculation = () => {
    const { distanceTravelled, fuelPerKm } = formData;
  
    const distance = parseFloat(distanceTravelled); // Convert to float to ensure it’s a number
    const ratePerLiter = parseFloat(fuelPerKm); // Convert fuel rate to float
  
    console.log("Distance:", distance, "Fuel Rate:", ratePerLiter); // Debugging logs
  
    if (distance && ratePerLiter && distance > 0) {
      const fuelRequired = distance / 15; // Distance divided by fuel efficiency (15 km per liter)
      const calculatedAmount = fuelRequired * ratePerLiter; 
  
      console.log("Fuel Required:", fuelRequired, "Calculated Amount:", calculatedAmount); 
  
      setFormData((prevData) => ({
        ...prevData,
        amount: calculatedAmount.toFixed(2), // Set amount with 2 decimal points
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        amount: "", // Clear amount if inputs are invalid
      }));
    }
  };
  
  useEffect(() => {
    handleTravelExpensesCalculation();
  }, [formData.distanceTravelled, fuelRate]); 

  const fetchFuelRate = async () => {
    try {
      if (formData.fuelType && formData.city) {
        const response = await fetch(
          `https//crm-nova.tagsol.in:8443/api/getFuelRate?fuelType=${formData.fuelType}&city=${formData.city}`
        );
        if (response.ok) {
          const data = await response.json();
          setFuelRate(data.fuelRate);
          setFormData((prevData) => ({ ...prevData, fuelPerKm: data.fuelRate }));
        } else {
          const errorData = await response.json();
          console.error("Error fetching fuel rate:", errorData.error || "Unknown error");
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    if (formData.fuelType && formData.city) {
      fetchFuelRate();
    }
  }, [formData.fuelType, formData.city]); 

  useEffect(() => {
    if (fuelRate) {
      handleTravelExpensesCalculation();
    }
  }, [fuelRate, formData.distanceTravelled]); 

  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');
    if (storedEmpId && storedEmpName && storedDesignation) {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    } else {
      alert('Session expired or employee details not found. Please log in again.');
      window.location.href = '/login';
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const form = new FormData();
    form.append('empId', empId);
    form.append('empName', empName);
    form.append('designation', designation);
    form.append('category', formData.category);
    form.append('amount', formData.amount);
    form.append('description', formData.description);
    form.append('startDate', formData.startDate);
    form.append('endDate', formData.endDate);
    form.append('campaignDescription', formData.campaignDescription);
    form.append('platform', formData.platform);
    form.append('expenseName', formData.expenseName);
    form.append('paymentMethod', formData.paymentMethod);
    form.append('travelExpenseMode', formData.travelExpenseMode);
    form.append('fuelType', formData.fuelType);
    form.append('fuelPerKm', formData.fuelPerKm);
    form.append('distanceTravelled', formData.distanceTravelled);
    form.append('accommodationType', formData.accommodationType);
    form.append('accommodationAmount', formData.accommodationAmount);
    form.append('accommodationDuration', formData.accommodationDuration);
    form.append('travelExpenseDescription', formData.travelExpenseDescription);
    form.append('city', formData.city);
  
    if (formData.receiptAttachment) {
      form.append('receiptAttachment', formData.receiptAttachment);
    }
    if (formData.accommodationReceipt) {
      form.append('accommodationReceipt', formData.accommodationReceipt);
    }
  
    try {
      const response = await fetch('https://cleezoclass.com:8443/api/expenses', {
        method: 'POST',
        body: form
      });
  
      if (response.ok) {
        const result = await response.json();
        setMessage('Expense added successfully!');
  
        // Reset form fields here
        setFormData({
          category: '',
          amount: '',
          description: '',
          startDate: '',
          endDate: '',
          campaignDescription: '',
          platform: '',
          expenseName: '',
          paymentMethod: '',
          receiptAttachment: null,
          travelExpenseMode: '',
          fuelType: '',
          fuelPerKm: '',
          distanceTravelled: '',
          accommodationType: '',
          accommodationAmount: '',
          accommodationDuration: '',
          accommodationReceipt: null,
          travelExpenseDescription: '',
          city: '', // Reset city as well
        });
      } else {
        const errorData = await response.json();
        setMessage(`Failed to add expense: ${errorData.error || 'Unknown error'}`);
        console.error('Error data:', errorData);
      }
    } catch (error) {
      setMessage('Error submitting expense.');
      console.error('Submit error:', error);
    }
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'category' && value !== formData.category) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        amount: "", 
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };
  return (
    <div className="expense-tracker-container">
      <h1 className="expense-h1">Expense Tracker</h1>
      <form onSubmit={handleSubmit} className="expense-form">
        {/* Employee ID */}
        <div className="form-group">
          <label htmlFor="empId">Employee ID:</label>
          <input
            type="text"
            id="empId"
            name="empId"
            value={empId}
            onChange={(e) => {
              setEmpId(e.target.value);
              if (e.target.value) {
                fetchEmployeeDetails(e.target.value);
              } else {
                setEmpName(""); // Reset name and designation when empId is cleared
                setDesignation("");
              }
            }}
            placeholder="Enter Employee ID"
            required
          />
        </div>

        {/* Employee Name */}
        <div className="form-group">
          <label htmlFor="empName">Employee Name:</label>
          <input
            type="text"
            id="empName"
            name="empName"
            value={empName}
            onChange={(e) => setEmpName(e.target.value)}
            placeholder="Employee Name"
            readOnly
          />
        </div>

        {/* Designation */}
        <div className="form-group">
          <label htmlFor="designation">Designation:</label>
          <input
            type="text"
            id="designation"
            name="designation"
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
            placeholder="Designation"
            readOnly
          />
        </div>

        {/* Expense Category */}
        <div className="form-group">
  <label htmlFor="category">Expense Category:</label>
  <select
    id="category"
    name="category"
    value={formData.category}
    onChange={handleInputChange}
    required
  >
    <option value="">Select a category</option>
    {categories.map((cat, index) => (
      <option key={index} value={cat}>
        {cat}
      </option>
    ))}
  </select>
</div>
  {/* Dynamic Fields based on Expense Category */}
        {formData.category === "Travel Expenses" && (
          <>
            <div className="form-group">
  <label htmlFor="travelExpenseMode">Travel Expense Mode:</label>
  <select
    id="travelExpenseMode"
    name="travelExpenseMode"
    value={formData.travelExpenseMode}
    onChange={handleInputChange}
  >
    <option value="">Select mode of travel</option>
    <option value="Car">Car</option>
    <option value="Bus">Bus</option>
    <option value="Auto">Auto</option>
    <option value="Cab">Cab</option>
    <option value="Flight">Flight</option>
    <option value="Bike">Bike</option>
  </select>
</div>
{/* Travel Dates */}
<div className="form-group">
  <label htmlFor="startDate">Start Date:</label>
  <input
    type="date"
    id="startDate"
    name="startDate"
    value={formData.startDate}
    onChange={handleInputChange}
  />
</div>
<div className="form-group">
  <label htmlFor="endDate">End Date:</label>
  <input
    type="date"
    id="endDate"
    name="endDate"
    value={formData.endDate}
    onChange={handleInputChange}
  />
</div>
<div className="form-group">
  <label htmlFor="fuelType">Fuel Type:</label>
  <select
    id="fuelType"
    name="fuelType"
    value={formData.fuelType}
    onChange={handleInputChange}
  >
    <option value="">Select fuel type</option>
    <option value="Petrol">Petrol</option>
    <option value="Diesel">Diesel</option>
    <option value="Electric">Electric</option>
  </select>
</div>
<div className="form-group">
  <label htmlFor="distanceTravelled">Distance Travelled (in km):</label>
  <input
    type="number"
    id="distanceTravelled"
    name="distanceTravelled"
    value={formData.distanceTravelled}
    onChange={handleInputChange}
    onBlur={handleTravelExpensesCalculation}
    placeholder="Enter distance in km"
  />
</div>
<div className="form-group">
  <label htmlFor="city">City:</label>
  <select
    name="city"
    value={formData.city} // Use formData.city
    onChange={(e) =>
      setFormData((prevData) => ({
        ...prevData,
        city: e.target.value,
      }))
    }
    required
  >
    <option value="">Select City</option>
    <option value="Hyderabad">Hyderabad</option>
    <option value="Chennai">Chennai</option>
    <option value="Bangalore">Bangalore</option>
    <option value="Delhi">Delhi</option>
    <option value="Mumbai">Mumbai</option>
  </select>
</div>
<div className="form-group">
  <label htmlFor="fuelPerKm">Fuel per Km:</label>
  <input
    type="number"
    id="fuelPerKm"
    name="fuelPerKm"
    value={formData.fuelPerKm}
    onChange={handleInputChange}
    onBlur={handleTravelExpensesCalculation}
    placeholder="Enter fuel rate per km"
  />
</div>       
<div className="form-group">
  <label htmlFor="amount">Amount (auto-calculated):</label>
  <input
    type="number"
    id="amount"
    name="amount"
    value={formData.amount}
    placeholder="Amount (auto-calculated)"
    readOnly
  />
</div>
            {/* Travel Expenses Description */}
            <div className="form-group">
  <label htmlFor="travelExpenseDescription">Description:</label>
  <textarea
    id="travelExpenseDescription"
    name="travelExpenseDescription"
    value={formData.travelExpenseDescription}
    onChange={handleInputChange}
    rows="2"
    placeholder="Enter description for travel expenses"
  ></textarea>
</div>          
          </>
        )}

{formData.category === "Marketing and Advertising" && (
          <>
            <div className="form-group">
              <label htmlFor="campaignDescription">Campaign Name/Description:</label>
              <input
                type="text"
                id="campaignDescription"
                name="campaignDescription"
                value={formData.campaignDescription}
                onChange={handleInputChange}
                placeholder="Enter campaign name or description"
              />
            </div>

            <div className="form-group form-row">
              <div className="form-item">
                <label htmlFor="startDate">Start Date:</label>
                <input
                  type="date"
                  id="startDate"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-item">
                <label htmlFor="endDate">End Date:</label>
                <input
                  type="date"
                  id="endDate"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="amount">Amount:</label>
              <input
                type="number"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                placeholder="Enter amount"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="platform">Platform:</label>
              <input
                type="text"
                id="platform"
                name="platform"
                value={formData.platform}
                onChange={handleInputChange}
                placeholder="Enter platform name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="2"
                placeholder="Enter description"
              ></textarea>
            </div>
          </>
        )}

{formData.category === "Miscellaneous Expenses" && (
          <>
            <div className="form-group">
              <label htmlFor="expenseName">Expense Name:</label>
              <input
                type="text"
                id="expenseName"
                name="expenseName"
                value={formData.expenseName}
                onChange={handleInputChange}
                placeholder="Enter expense name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="amount">Amount:</label>
              <input
                type="number"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleInputChange}
                placeholder="Enter amount"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="paymentMethod">Payment Method:</label>
              <select
                id="paymentMethod"
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
              >
                <option value="">Select payment method</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
                <option value="Cash">Cash</option>
                <option value="Bank Transfer">Bank Transfer</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="receiptAttachment">Receipt Attachment:</label>
              <input
                type="file"
                id="receiptAttachment"
                name="receiptAttachment"
                onChange={handleFileChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="2"
                placeholder="Enter description"
              ></textarea>
            </div>
          </>
        )}


{formData.category === "Accommodation Expenses" && (
  <>
     <div className="form-group">
  <label htmlFor="accommodationType">Accommodation Type:</label>
  <select
    id="accommodationType"
    name="accommodationType"
    value={formData.accommodationType}
    onChange={handleInputChange}
  >
    <option value="">Select accommodation type</option>
    <option value="Hotel">Hotel</option>
    <option value="Hostel">Hostel</option>
    <option value="Airbnb">Airbnb</option>
    <option value="Other">Other</option>
  </select>
</div>


{/* Travel Dates */}
<div className="form-group">
  <label htmlFor="startDate">Start Date:</label>
  <input
    type="date"
    id="startDate"
    name="startDate"
    value={formData.startDate}
    onChange={handleInputChange}
  />
</div>

<div className="form-group">
  <label htmlFor="endDate">End Date:</label>
  <input
    type="date"
    id="endDate"
    name="endDate"
    value={formData.endDate}
    onChange={handleInputChange}
  />
</div>
<div className="form-group">
  <label htmlFor="accommodationAmount">Accommodation Amount:</label>
  <input
    type="number"
    id="accommodationAmount"
    name="accommodationAmount"
    value={formData.accommodationAmount}
    onChange={handleInputChange}
    placeholder="Amount spent on accommodation"
  />
</div>
<div className="form-group">
  <label htmlFor="accommodationDuration">Accommodation Duration (in nights):</label>
  <input
    type="number"
    id="accommodationDuration"
    name="accommodationDuration"
    value={formData.accommodationDuration}
    onChange={handleInputChange}
    placeholder="Number of nights"
  />
</div>

<div className="form-group">
              <label htmlFor="paymentMethod">Payment Method:</label>
              <select
                id="paymentMethod"
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
              >
                <option value="">Select payment method</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
                <option value="Cash">Cash</option>
                <option value="Bank Transfer">Bank Transfer</option>
              </select>
            </div>
<div className="form-group">
  <label htmlFor="accommodationReceipt">Accommodation Receipt:</label>
  <input
    type="file"
    id="accommodationReceipt"
    name="accommodationReceipt"
    onChange={handleFileChange}
    accept="image/*,.pdf"
  />
</div>

          </>
        )}

        {/* Submit Button */}
        <div className="button-container">
          <button type="submit" className="add-expense-btn">Add Expense</button>
        </div>
        {/* Display success or error message */}
        {message && (
          <div style={{ marginTop: '10px', color: message.includes('successfully') ? 'green' : 'red' }}>
            {message}
          </div>
        )}
      </form>

      {expenses.length > 0 && (
        <div>
          <h3>Approval Details</h3>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>EmpId</th>
                <th>Approval Status</th>
                <th>Updated At</th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((expense) => (
                <tr key={expense.id}>
                  <td>{expense.id}</td>
                  <td>{expense.empId}</td>
                  <td>{expense.approvalStatus}</td>
                  <td>{new Date(expense.updatedAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
  

export default ExpenseTracker;